import { render } from "./NotOptimizedViewportModal.vue?vue&type=template&id=5a442ccf&scoped=true"
import script from "./NotOptimizedViewportModal.vue?vue&type=script&lang=js"
export * from "./NotOptimizedViewportModal.vue?vue&type=script&lang=js"

import "../../assets/scss/document_viewport_modal.scss?vue&type=style&index=0&id=5a442ccf&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a442ccf"]])

export default __exports__